// ==================================
// Servicio de Autenticacion
// ==================================

import api from './api';
import type { LoginCredentials, LoginResponse, ApiResponse } from '@/tipos';

export const authServicio = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await api.post<ApiResponse<LoginResponse>>(
      '/admin/auth/login',
      credentials
    );
    return response.data.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/admin/auth/logout');
  },

  refreshToken: async (refreshToken: string): Promise<{ accessToken: string }> => {
    const response = await api.post<ApiResponse<{ accessToken: string }>>(
      '/admin/auth/refresh',
      { refreshToken }
    );
    return response.data.data;
  },

  verificarSesion: async (): Promise<boolean> => {
    try {
      await api.get('/admin/auth/verificar');
      return true;
    } catch {
      return false;
    }
  },
};

export default authServicio;
